import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, SearchIcon, ShoppingCartIcon, MenuIcon } from 'lucide-react';
import { MobileSearchOverlay } from '../shared/MobileSearchOverlay';
import { useStore } from '../../lib/store';
interface MobileInternalHeaderProps {
  title: string;
  showActions?: boolean;
  showMenu?: boolean;
  onMenuClick?: () => void;
}
export function MobileInternalHeader({
  title,
  showActions = true,
  showMenu = true,
  onMenuClick
}: MobileInternalHeaderProps) {
  const navigate = useNavigate();
  const cartCount = useStore(state => state.cartCount());
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  return <>
      <header className="md:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-100 z-50 flex items-center px-4 safe-area-top" data-id="element-2876" data-mp="105i8wq1a44pn">
      {/* Back Button */}
      <button type="button" onClick={() => navigate(-1)} aria-label="Go back" className="p-2 -ml-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-2877" data-mp="31wlmno6gtzef">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-2878" data-mp="18yxvsxxlfwy8" />
      </button>

      {/* Title */}
      <h1 className="flex-1 text-base font-bold text-gray-900 truncate ml-2" data-id="element-2879" data-mp="142fte4pqkap2">
        {title}
      </h1>

      {/* Actions */}
      {showActions && <div className="flex items-center gap-1" data-id="element-2880" data-mp="1wr4zyj9k9887">
          <button type="button" onClick={() => setIsSearchOpen(true)} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Search" data-id="element-2881" data-mp="1wptvsic7dygk">
            <SearchIcon className="w-5 h-5" data-id="element-2882" data-mp="1ht2wsa6fyorh" />
          </button>

          <button type="button" onClick={() => navigate('/cart')} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Cart" data-id="element-2883" data-mp="bebmxgzcbtlb">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-2884" data-mp="2ykofsg7w9diu" />
            {cartCount > 0 && <span className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center border border-white" data-id="element-2885" data-mp="2kmq5pn0lw395">
                {cartCount}
              </span>}
          </button>

          {showMenu && <button type="button" onClick={onMenuClick ?? (() => navigate('/menu'))} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Menu" data-id="element-2886" data-mp="2fmu2vr3nahv6">
            <MenuIcon className="w-5 h-5" data-id="element-2887" data-mp="1rwrcdffdpjyo" />
          </button>}
        </div>}
      </header>
      <MobileSearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} data-id="element-2888" data-mp="1wwvutazukorj" />
    </>;
}